import { cn, Button } from '@wellesley/ui'
import { forwardRef, PropsWithChildren } from 'react'
import UploadButton from '@wellesley/uploads/components/UploadButton'
import { Trash2 } from 'lucide-react'

export type ChangeEventImgProps = PropsWithChildren<{
  accept: string
  onChange: (props: UploadFileProps[]) => void
  onDelete?: () => void
  className?: string
  disabled?: boolean
}>

export type UploadFileProps = {
  file: File
  objectUrl: string
}

const ChangeEventImg = forwardRef<HTMLInputElement, ChangeEventImgProps>(
  ({ accept, children, className, onDelete, onChange, disabled }, ref) => {
    const dataId = children?.toString().includes('Cover')
      ? 'changeCover'
      : 'changeAvatar'

    const commonButtonProps = {
      variant: 'secondary' as const,
      size: 's' as const,
      ...(disabled ? { disabled: true } : { as: 'label' as const }),
    }

    return (
      <div
        data-testid={dataId}
        className={cn(
          'my-xxs flex cursor-pointer items-center gap-xxs md:my-none',
          className,
        )}
      >
        <Button {...commonButtonProps} className="cursor-pointer">
          {children}
          <UploadButton ref={ref} accept={accept} onChange={onChange} />
        </Button>

        {onDelete && (
          <Button
            type="button"
            data-testid="delete"
            variant="secondary"
            size="icon_m"
            className="rounded-m"
            onClick={onDelete}
            disabled={disabled}
          >
            <Trash2 size={20} />
          </Button>
        )}
      </div>
    )
  },
)

ChangeEventImg.displayName = 'ChangeEventImg'

export default ChangeEventImg
